import { Injectable } from '@angular/core';

import { ThemeOptions } from '@shared/restaurant/models';

@Injectable({ providedIn: 'root' })
export class ThemeOptionsService {
  getThemeCssVariables(theme: ThemeOptions): { [cssVraName: string]: string } {
    return {
      '--backgroundColor': theme.backgroundColor,
      '--bodyColor': theme.bodyColor,
      '--header1Color': theme.header1Color,
      '--header2Color': theme.header2Color,
      '--estimatedWaitColor': theme.estimatedWaitColor,
      '--header3Color': theme.header3Color,
      '--addButtonColor': theme.addButtonColor,
      '--addButtonBackgroundColor': theme.addButtonBackgroundColor,
      '--formBackgroundColor': theme.formBackgroundColor,
      '--tableHeaderColor': theme.tableHeaderColor,
      '--highlightColor': theme.highlightColor,
      '--footerColor': theme.footerColor,
    };
  }
}
